(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerModalController', CompanyCustomerModalController);

    CompanyCustomerModalController.$inject = ['$rootScope', '$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader', '$timeout'];

    function CompanyCustomerModalController($rootScope, $scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader, $timeout) {

        var vm = this;
        vm.companyCustomer = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.getCompanyCustomerFormDataFunc = getCompanyCustomerFormDataFunc;
        vm.editCompanyCustomerFormDataFunc = editCompanyCustomerFormDataFunc;
        vm.hasAllNecessaryFields = false;
        vm.customerFormData = null;
        vm.columnCount = null;

        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.gotoNewReserve = gotoNewReserve;
        vm.getModalTitle = getModalTitle;
        vm.callCustomer = callCustomer;


        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $rootScope.$broadcast('hideNavBar');
            window.scroll(0, 0);

        }

        function getCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle) {

            CompanyCustomerCustom.getNewCompanyCustomerFormData(companyCustomFormId).query(function (res) {

                vm.customerFormData = res;
                vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
                vm.customerFormData.companyCustomer = vm.companyCustomer;
                openEditDataDialog(vm.customerFormData);

            });
        }

        // function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {
        function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {

            vm.customerFormData = data;
            vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
            vm.customerFormData.companyCustomer = vm.companyCustomer;
            openEditDataDialog(vm.customerFormData);
        }

        // function openEditDataDialog(customerFormData) {
        //     vm.columnCount = 4 ;
        //     $mdDialog.show({
        //         locals: {dialogData: customerFormData , columnCount: vm.columnCount},
        //         controller: ComponentIntakeDataDialogController,
        //         templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
        //         controllerAs: '$ctrl',
        //         parent: angular.element(document.body),
        //         targetEvent: customerFormData,
        //         clickOutsideToClose: true
        //     })
        //         .then(function (answer) {
        //             $scope.status = 'You said the information was "' + answer + '".';
        //         }, function () {
        //             $scope.status = 'You cancelled the dialog.';
        //         });
        // };

        function save() {
            vm.isSaving = true;

            if (vm.companyCustomer.id !== null) {
                CompanyCustomerCustom.updateCompanyCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
            } else {
                if (vm.companyCustomer.customer !== null) {
                    CompanyCustomerCustom.addNewCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
                }

            }


            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:companyCustomerUpdate', result);
                vm.isSaving = false;

                if ($state.current.name
                    && ($state.current.name == 'supplierPanel-v2.newReserve'
                        || $state.current.name == 'supplierPanel-v2.new-reserve-modal'
                        || $state.current.name == 'supplierPanel-v2.dashboard.newReserve'
                        || $state.current.name == 'supplierPanel-v2.newInvoiceInfo'
                        || $state.current.name == 'supplierPanel-v2.invoiceInfoDetail'
                    )
                ) {
                    if ($rootScope.modalInstance) {
                        $rootScope.modalInstance.close(result);
                        return;
                    }
                }

                if ($rootScope.fromState && $rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoDetail'
                    && $rootScope.fromStateParams
                ) {
                    $state.go('supplierPanel-v2.invoiceInfoDetail', {id: $rootScope.fromStateParams.id});
                    return;
                }


                if ($rootScope.fromState && $rootScope.fromState.name == 'supplierPanel-v2.editOrderBag'
                    && $rootScope.fromStateParams
                ) {
                    $state.go('supplierPanel-v2.editOrderBag', {id: $rootScope.fromStateParams.id});
                } else if ($rootScope.fromState && $rootScope.fromState.name && $rootScope.fromState.name == 'supplierPanel-v2.reserveList') {
                    $state.go('supplierPanel-v2.reserveList');
                } else {
                    $state.go('supplierPanel-v2.companyCustomer.edit', {id: result.id});
                }

                loadAll();
            }

        }

        function okModal() {
            save();

        }

        function closeModal() {

            if ($state.current.name
                && ($state.current.name == 'supplierPanel-v2.newReserve'
                    || $state.current.name == 'supplierPanel-v2.new-reserve-modal'
                    || $state.current.name == 'supplierPanel-v2.dashboard.newReserve'
                    || $state.current.name == 'supplierPanel-v2.newInvoiceInfo'
                    || $state.current.name == 'supplierPanel-v2.editInvoiceInfo'
                    || $state.current.name == 'supplierPanel-v2.invoiceInfoDetail'
                )
            ) {
                if ($rootScope.modalInstance) {
                    $rootScope.modalInstance.dismiss('cancel');
                    return;
                }
            }

            $rootScope.$broadcast('showNavBar');

            if ($rootScope.fromState && $rootScope.fromState.name && $rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoDetail'
                && $rootScope.fromStateParams && $rootScope.fromStateParams.id
            ) {
                $state.go('supplierPanel-v2.invoiceInfoDetail', {id: $rootScope.fromStateParams.id});
                return;
            }

            if ($rootScope.fromState && $rootScope.fromState.name && $rootScope.fromState.name == 'supplierPanel-v2.editOrderBag'
                && $rootScope.fromStateParams && $rootScope.fromStateParams.id
            ) {
                $state.go('supplierPanel-v2.editOrderBag', {id: $rootScope.fromStateParams.id});
            } else if ($rootScope.fromState && $rootScope.fromState.name && $rootScope.fromState.name == 'supplierPanel-v2.reserveList') {
                $state.go('supplierPanel-v2.reserveList');
            } else {
                $state.go('supplierPanel-v2.companyCustomer', $rootScope.fromStateParams);
            }

        }


        function gotoNewReserve() {
            $state.go('supplierPanel-v2.reserveWithCustomerParameter', {
                customerId: vm.companyCustomer.customer.id
            });
        }

        function getModalTitle() {
            if (vm.companyCustomer.id)
                return 'tikonApp.companyCustomer.home.viewAndEditCustomer';
            else
                return 'tikonApp.companyCustomer.home.createLabel';
        }

        function callCustomer() {
            if (vm.companyCustomer && vm.companyCustomer.customer && vm.companyCustomer.customer.personalInfo.phoneNumber)
                window.open("tel:" + vm.companyCustomer.customer.personalInfo.phoneNumber);
        }
    }
})();
